'use strict';

var _ = require('lodash');

/**
 * Market Analysis - Market Product tab - select row - Service Share from menu - Charts
 */
var ServiceDemandAdjustmentTransformerFactory = function ServiceDemandAdjustmentTransformerFactory($filter, DataTransformer, momentService, configurationService, featureToggleService, timeOfDayBucketStateService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function ServiceDemandAdjustmentTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'service-share';
    this.targetType = ['demand-adjustment-time-of-day', 'demand-adjustment-fare', 'demand-adjustment-number-of-stops'];
    this.priority = 1;
  }
  ServiceDemandAdjustmentTransformer.prototype = Object.create(DataTransformer.prototype);
  ServiceDemandAdjustmentTransformer.constructor = ServiceDemandAdjustmentTransformer;
  ServiceDemandAdjustmentTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  ServiceDemandAdjustmentTransformer.prototype.isCacheable = function () {
    return false;
  };
  ServiceDemandAdjustmentTransformer.prototype.transform = function (data) {
    var mappedModeEnabled = featureToggleService.isEnabled('MAPPED_MODE');
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedTimeOfDayOfMoment = _.memoize(getTimeOfDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var filteredServices = _.filter(data.domain.serviceClassPOS, function (serviceClassPOS) {
      return !serviceClassPOS.isDiscontinued;
    });
    var firstItem = _.first(filteredServices);
    var classes = configurationService.getClassGroupConfigByMarket(_.get(firstItem, 'market'));
    return _.transform(filteredServices, function (result, entry) {
      var momentDepartureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
      var curYMD = memoizedYearMonthDayOfMoment(momentDepartureDate);
      var curTODMoment = memoizedTimeOfDayOfMoment(momentDepartureDate);
      var newEntry = {};
      newEntry.departureDateMoment = momentDepartureDate;
      newEntry.departureDateMomentTimeOfDay = curTODMoment;
      newEntry.departureDate = curYMD;
      newEntry.numberOfStops = entry.numberOfStops ? entry.numberOfStops : 0;
      newEntry.fare = mappedModeEnabled ? entry.fare : entry.mappedFare;
      newEntry.proratedFare = mappedModeEnabled ? entry.proratedFare : entry.mappedProratedFare;
      newEntry.classIndex = getClassIndex(classes, entry.className, newEntry.fare);
      newEntry.classGroup = entry.classGroup;
      newEntry.significantPOS = entry.sposName;
      newEntry.entry = entry;
      return result.push(newEntry);
    });
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  function getClassIndex(classes, className, defaultValue) {
    var clazz = _.find(classes, ['className', className]);
    return _.get(clazz, 'classIndex', defaultValue);
  }

  /**
   *
   * @param moment
   * @param hour
   * @param minutes
   * @returns {MomentFactory}
   */
  function createMomentFromHour(moment, hour, minutes) {
    var dateString = rmMomentFormat(moment, 'DATE_ISO') + ' ' + hour + minutes;
    return momentService.of(dateString, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE_HOURS_MINUTES);
  }
  function getTimeOfDayOfMoment(moment) {
    var todBucket = timeOfDayBucketStateService.getState('TOD') || 3;
    var cloned = moment.clone();
    var bucket = cloned.hours() - cloned.hours() % todBucket;
    var start = createMomentFromHour(cloned, bucket, ':00');
    var end = createMomentFromHour(cloned, Math.min(24, bucket + todBucket) - 1, ':59');
    return [rmMomentFormat(start, momentService.TIME_USER_SETTINGS), rmMomentFormat(end, momentService.TIME_USER_SETTINGS)].join('-');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return ServiceDemandAdjustmentTransformer;
};
ServiceDemandAdjustmentTransformerFactory.$inject = ['$filter', 'DataTransformerFactory', 'MomentService', 'ConfigurationService', 'FeatureToggleService', 'TimeOfDayBucketStateService'];
module.exports = ServiceDemandAdjustmentTransformerFactory;